/**
 * Tools Data
 * Static tool definitions from data/tools.md
 */

export const toolsData = {
  'T-001': {
    id: 'T-001',
    name: 'Five Principles of the Soul\'s Journey',
    content: `
1. You are a soul having an earthly experience.
2. You are a soul on an evolutionary path.
3. Evolution of a soul happens through life experience.
4. Your evolutionary path has a certain direction.
5. You evolve by discovering and integrating different parts of yourself.
    `
  },
  'T-002': {
    id: 'T-002',
    name: 'First-Aid Kit for Acute Situation and Emergency',
    content: `
Do some or all of the following when you receive a shock to your system. 
If the situation involves danger to your physical safety, make sure to secure it first by calling for help and/or moving away from the scene. 

1. Feel your feet touching the floor or ground, being supported by it. 
2. Cross your arms and gently hold the forearms with the palms of your hands. Feel the warmth of your hands transmitted to the part of the forearms being touched. 
3. Look around and count three things you like or catch your attention.
4. Say your names three times.

- Keep a routine schedule after a shock and during recovery.
- Go out in nature if you can, or imagine that you are held by your favorite spot in nature.
- Ask for professional help for working through the experience when the issue persists, and/or when support from your immediate community is not readily available nor appropriate.
    `
  },
  'T-003': {
    id: 'T-003',
    name: 'Consciousness First-Aid Kit for an Acute Situation',
    content: `
1. Please take a seat and take a few deep breaths. 
2. Close your eyes and imagine that a compassionate friend or a supportive "spirit being" is with you. How does it feel to be in their presence?
3. Slowly shift your viewpoint and imagine yourself becoming the friend or spirit watching over you. You may be hovering over your usual self, sitting beside you, or standing behind you. Imagine you are trying to energetically heal and comfort the one in pain.
4. What do you notice about the one on the chair? 
5. What would you do as the compassionate spirit? (e.g., laying hands on your shoulders, holding your hands, just being there.)
6. Take one more step back and now become the observer who is looking at both the one sitting in the chair and the one comforting them.
7. What do you notice? 
8. How does it feel to be the removed observer?
9. When you are ready, come back and bring your awareness to how the ground supports your feet. 
    `
  },
  'T-004': {
    id: 'T-004',
    name: 'Accessing Inner Stillness',
    content: `
1. Sit comfortably. Exhale slowly and gently through your nose, imagining you are breathing out whatever is on your mind and whatever you are feeling. Then inhale naturally through the nose, imagining fresh air coming into your lungs. Repeat a couple of times. 
2. This time, as you empty out the last bit of air, gently bring your awareness to the quiet space within yourself just for a second before inhaling. 
3. Inhale gently and naturally, then exhale, again bringing your gentle attention to the stillness in yourself for just a second before you breathe in. 
4. Continue breathing naturally and slowly while noticing the stillness before the next breath. 
5. Continue as long as you feel necessary until you start noticing your mind and your body becoming still and relaxed. 
    `
  },
  'T-005': {
    id: 'T-005',
    name: 'Grounding Techniques',
    content: `
Do one or more of the following:
- Feel your feet touching the floor or ground, being supported by it. 
- Stand on natural surfaces, such as earth, grass, and sand. 
- Pat down your thighs and calves rhythmically. 
- Engage your five senses. For example, look around the room and name three things you like. Hold a stone and notice its texture and weight. 
    `
  },
  'T-006': {
    id: 'T-006',
    name: 'Vertical Centering Meditation',
    content: `
1. Sit on a chair or stand with your feet on the floor. If a situation allows you, stand barefoot on a natural surface, such as soil, sand, or grass. 
2. Close your eyes and feel how the soles of your feet are supported by the earth beneath you. Visualize the roots extending from the soles of your feet all the way down. 
3. Now bring your attention to the sky right above you. There is the North Star, Polaris. Feel your connection to it, how it is stretching you. Let it stretch your neck and your spine. Just notice how it feels.
4. Now, bring your attention to your center, the heart. 
5. Once again, bring your attention to the connection with the Earth, Polaris, and your heart in the middle. Feel the three are in perfect alignment.
    `
  },
  'T-007': {
    id: 'T-007',
    name: 'Strengthening Energetic Boundary 1',
    content: `
Imagine being in a bubble of translucent, membrane-like sheath. What size would feel most comfortable for you? Imagine that the sheath has an intelligent design that lets you see and interact with the outside world while protecting you from harm. The space inside is quiet and belongs only to you. How do you feel about being inside of this bubble? 
    `
  },
  'T-008': {
    id: 'T-008',
    name: 'Strengthening Energetic Boundary 2',
    content: `
1. Draw a shape of a figure representing you in the center of a piece of paper.
2. Close your eyes, relax, and visualize being surrounded by a bubble of light protecting you from everything outside. It protects you but is also translucent so that you can observe what is outside. How does it feel in your body to be inside this bubble?  
3. Now, open your eyes and encircle the figure in a way you like, as if you are creating an energetic membrane around it. 
4. Now, take a moment to view the picture. How does it feel to look at it? While you look at the picture, try to sense a similar kind of shield around you.  
    `
  },
  'T-009': {
    id: 'T-009',
    name: 'Five Pillars of Well-being',
    content: `
- Clean water and air, good quality foods 
- Physical exercise appropriate for your body 
- Good quality sleep 
- Connection with people you trust 
- Connection with nature & the divine
    `
  },
  'T-010': {
    id: 'T-010',
    name: 'Connecting with Helper Energy',
    content: `
- Have a pillow ready for this exercise.

1. Take a couple of deep breaths, accessing your inner stillness. Think of a character, real or imaginary, or a part of nature that you feel supported by unconditionally. On a piece of paper, quickly draw its energy. 
2. Imagine that you are accompanied by the compassionate presence. Where do you want it to be relative to you, e.g., standing beside you, behind you, hovering above you, or all around you? Imagine the helper is there for you. If the helper is a part of nature, visualize you are held by it. Notice how you feel in your body in its presence. (If you would like to explore further, go on to the step 3. Otherwise, jump to 4.) 
3. Now, slowly shift your perspective and step into the position of the helper. Designate a pillow to represent your usual self. You are now looking at yourself in front of you, below you, etc. Feel free to interact with, watch over, or give advice to the pillow/your usual self, acting as the compassionate helper. (Shift back and forth between the two perspectives a couple of times.)
4. Remember the feelings and the sensations you have in the presence of the compassionate energy once again. Know that you can always access them whenever you need.
    `
  },
  'T-011': {
    id: 'T-011',
    name: 'Body Scanning',
    content: `
Relax and scan your body slowly from head to toe, as if you are exploring an unknown land. Notice subtle sensations, movement, or peculiar ways in which you are holding your body. Notice if there is any tension in your body. Maybe there is a certain direction toward which your body is trying to move. Try not to judge what it means or to find a cause, but just notice what is there.
    `
  },
  'T-012': {
    id: 'T-012',
    name: 'Body Awareness Meditation',
    content: `
1. Close your eyes and relax. Take a couple of deep and relaxing breaths. Now, scan your body slowly from head to toe, noticing any subtle sensations, movement, or peculiar ways in which you are holding your body. 
2. Choose one part of the body that is especially calling your attention at this moment. Bring your gentle awareness to the part as if you were greeting a guest. Hold your attention there without judgment or naming it, and just feel it.  
3. Imagine breathing through that part of the body. Visualize the air first going into that part of the body as you breathe in, then the air going out through that part as you breathe out. Just stay with it and keep on breathing into the part. How does it feel now?
4. If the part of the body were to communicate with you, what would it say? Note any message that may come to you as well as your reaction to it. 
5. Give gratitude to the experience in the body for bringing you the awareness, and slowly open your eyes.
    `
  },
  'T-013': {
    id: 'T-013',
    name: 'Vantage Point Technique 1 (simple version)',
    content: `
1. Think of a situation or a person that you want to know more about. Who are the people involved and what is the situation? 
2. Relax your body and take a couple of deep breaths while noticing the stillness between breaths. Now, imagine that you are now slowly lifting yourself up to a higher place and now witnessing "you in the situation" below you, as a removed observer. 
3. How does the whole scene look from the vantage point? Do you notice anything that you have not before? Do you have any insight as to what the situation or "you in the situation" may need? 
    `
  },
  'T-014': {
    id: 'T-014',
    name: 'Vantage Point Technique 2 (longer version)',
    content: `
1. Think of a situation or a person that disturbs you and you have a mild emotional reaction to. Who are the people involved, including yourself, and what does each person stand for? 
2. Designate a small piece of paper for one position or a person and draw a symbol or a picture to represent it. Repeat for the rest of the character(s).
3. Now, arrange the papers on the floor to represent the situation, as if they were the real people and the situation. Now, stand up and look at the whole picture below you as if looking at it from a mountaintop. 
4. How does the situation look now from that viewpoint? Do you notice anything that you have not noticed before? 
5. Go ahead and move around the pieces and play with them. For example, you may feel like distancing one character from another or making them closer. If you feel the situation is missing another piece, feel free to create one and place it where you feel it belongs. For instance, you might feel that some characters need a wall between them. You might feel another character needs to be introduced to step in. 
6. After a while, look at the scene again. How does it feel to look at it now? From what you see, can you think of an actual step you can take to resolve the real-life situation?  
    `
  },
  'T-015': {
    id: 'T-015',
    name: 'Identifying Different Parts, Positions or Voices (for Inner Conflict)',
    content: `
1. Using "Vantage Point Technique 1", observe yourself having an inner conflict, tension or emotional reaction to something. 
2. If you already know what different inner parts, positions, or voices are present in yourself, write down each voice on a separate piece of paper. Proceed to step 5.
3. If you are not clear about different inner parts in yourself, what is the inner voice, feeling, or thought that is the most clear to you? Then, write down on a piece of paper as if it was a separate person with the experience. (For example, if you are feeling down, you can write "someone who is feeling down". If you are frustrated that you have a lot of work, write "someone who is burdened with work.") 
4. Then find other parts in yourself by asking the following questions, then write down on separate pieces of paper as if they were different people:
- "What kind of inner voice am I having this reaction to?"
- "What is the object of my emotion or tension?"
- "What kind of inner voice is causing this tension?"
For example, if you are feeling down, there may be "someone who puts you down". If you are frustrated with overwork, there may be "someone who forces you to work hard", as well as "someone who wants to take a break" within yourself. 
5. Put those pieces of paper on a table or on the floor and look at them from a third person's perspective or a vantage point. They are different inner voices/positions/parts within you. Use the tool "Vantage Point Technique 2" to explore further or resolve the inner tension. 
    `
  },
  'T-016': {
    id: 'T-016',
    name: 'Identifying Different Parts, Positions or Voices (for Conflict with Someone)',
    content: `
1. Think of a situation that is giving you tension in which another person is involved, such as conflict and argument. What is the situation and who is the other person?  
2. Relax your body and take a couple of deep breaths while noticing the stillness between breaths. What is your position in this situation? What are your thoughts and feelings? What do you stand for?  What is your deepest hope in this position? Write down on a piece of paper.
3. Next, think of the other party in this situation.  If you can, imagine that you put yourself in their shoes temporarily and feel into their position. What do you imagine their feelings, thoughts and position are? What do they stand for? What is their deepest hope in this position? Write down on a separate piece of paper. 
4. Place those pieces of paper on a table or floor and look at them.  How does the whole scene look from the vantage point? Is there any common ground between these positions/voices? What part of me is the other position reflecting? Do you have any insight as to what the situation or "you in the situation" may need to resolve the conflict or tension? 
    `
  },
  'T-017': {
    id: 'T-017',
    name: 'Identifying Different Parts, Positions or Voices (in Group)',
    content: `
1. Think of a situation involving a group that you want to know more about. Who are the people involved and what different opinions, positions and stances are present? 
2. Write down each position on a piece of paper. 
3. First, hold the paper with the position that you feel the most closest to, and feel into it. What is its deepest hope? Write it down on the paper. What is its energy like? Using the tool "Energy Drawing", add the energy sketch to the paper also. 
4. Hold the other pieces one by one and do the above step. 
5. Place all the pieces of paper you have created on a table or floor. Relax your body and take a couple of deep breaths while noticing the stillness between breaths. Now, imagine that you are now slowly lifting yourself up to a higher place and now witnessing the situation in the group from a vantage point, as a removed observer. 
6. How does the whole scene look from the vantage point? Do you notice anything that you have not before? Which voice represents majority? What is the voice that is least represented? Can you see parts of you reflected in others positions that you are not identified with? Is there any part, voice, position or energy that you feel is missing from this picture? If so, go ahead and create another piece and introduce into the scene. Do you have any insight as to what else might help the situation? 
    `
  },
  'T-018': {
    id: 'T-018',
    name: 'Seeing Things as Energy',
    content: `
Create inner stillness first, then bring your gentle attention to the object, person or situation you want to know more about. Try to see it as a manifestation of some kind of energy with a certain vibration Withholding any judgment, observe its unique and special "feel" and vibration. (Alternately, use the tool "Energy Drawing" ). 
    `
  },
  'T-019': {
    id: 'T-019',
    name: 'Energy Drawing',
    content: `
1. Bring your gentle attention to the object, person or situation you want to know more about. Try to see it as a manifestation of some kind of energy with its unique vibration. Feel its special energy.
2. Quickly sketch its "energy", i.e. draw the energy of what you are trying to explore, not the thing itself or your reaction to it. It should look like an abstract sketch or a doodle. Do not think and let your hand draw. Do it quickly, by not taking more than 30 seconds. 
3. At this point, please set aside the object itself. Look at the drawing, which is an expression of a neutral energy. How would you describe "it" in neutral, non-judgmental terms? 
    `
  },
  'T-020': {
    id: 'T-020',
    name: 'Distilling Energy',
    content: `
1. Take a couple of deep breaths. Think of or look at an object, person, or situation that you would like to know more about. 
2. Try to see it as the manifestation of some kind of energy with its unique vibration, as if you were allowing it to reveal its nature to you. Feel its special energy. What would you say its quality is? Try to describe it in as neutral terms as possible, withholding judgment. 
3. Check if the energy you just extracted has a negative connotation. If so, distill it until it becomes a neutral or even positive word. 
4. If it's difficult to find neutral words to describe the energy, try the following techniques or questions:
- Use the tool Energy Drawing. Set aside the original thing you were thinking about, and just look at the energy sketch itself. How would you describe it? 
- Try one or some of the following questions:
  - What is its special power that is unique to them? 
  - If it was an animal/building structure/vehicle/part of nature, what would it be? What is its energy? (You can also combine this question with the Energy Drawing tool.)
    `
  },
  'T-021': {
    id: 'T-021',
    name: 'Polarity Work',
    content: `
1. Have a piece of paper ready. Draw two circles at each end of the paper as below. Write in the left circle a few words that describe an energy that you find outside of yourself or within yourself that catches your attention and gives you some kind of tension. Using "Distilling Energy" tool, describe the energy as neutrally as possible without judgment. 
2. What is the opposite of energy or quality? Describe it using words that are as judgment-free as possible. Write it in the right circle.  
3. Now connect the two circles with a line as shown on the next page. Which one feels more familiar, and which one feels less known to you? Mark the line where you feel you are most of the time in your everyday life. The path from the familiar energy leading to the less familiar is your soul direction at this point in life. 
    `
  },
  'T-022': {
    id: 'T-022',
    name: 'Identify Your Relationship to Different Energies',
    content: `
1. Think of an energy that you find outside of yourself or within yourself that catches your attention or gives you some kind of tension. Using such tools as "Distilling Energy" and "Energy Drawing", explore the energy further.
2. Is the energy familiar to you and closer to your everyday self? Does the energy have quality that is closer to your South Node of the Moon quality? You can also identify your relationship to this energy using the tool "Polarity Work".  If you find that the energy is closer to your familiar self, consider how this energy has helped you in your life. Does the energy still support you or do you feel it is no longer serving you?  
3. Is the energy new to you and different from what you are comfortable with? Does the energy have quality that is closer to your North Node? What is stopping you from living this newly emerging energy more? What would help you to explore and live this energy more?  Consider using one/some of the Integration Tools for support. 
    `
  },
  'T-023': {
    id: 'T-023',
    name: 'Embodying New Energy (general)',
    content: `
1. Bring your gentle attention to the object, person or situation you want to know more about. Notice that it has a special "feel" to it. Feel its special energy and vibration. What would you say its quality is? Try to describe it in as neutral terms as possible, withholding judgment. (Use the tool "Distilling Energy").
2. Feel the energy slowly entering a part of your body, then throughout the body. How do you feel in your body and mind now? How do you see the world around you and in what kind of attitude would you participate in it? 
3. What would you do, or how would you deal with an issue in a way that contribute to your life as well as the world around you? 
    `
  },
  'T-024': {
    id: 'T-024',
    name: 'Connecting with New Energy through a Role Model',
    content: `
1. Think of a new energy in yourself that you would like to know more about, (for example, your North Node of the Moon quality) and ask yourself "who would embody it in a positive way?" Alternately, think of a person who has a very different quality from you that you admire. 
2. Close your eyes and imagine that you have a screen in front of you. Imagine that you are in a town where many people are walking. All of a sudden someone stands out from the crowd. It is the person you chose above. Observe the person closely.  
3. Imagine them going about their daily lives. How do they carry themselves? What is their attitude toward other people? How do they live their life in general? 
4. What is their posture like? Take a minute to imagine you are that person and walk around the room with their posture and gait. How does it feel in your body and mind now? 
5. With this energy, how would you spend your day, engage with others, deal with problems, and so on? How would you use this energy in your unique way? 
    `
  },
  'T-025': {
    id: 'T-025',
    name: 'Connecting with Energy through Energy Drawing',
    content: `
1. Bring your gentle attention to the object, person or situation you want to know more about. Notice that it has a special "feel" to it. Feel its special energy.
2. Quickly sketch its "energy", i.e. draw the energy of what you are trying to explore, not the thing itself or your reaction to it. It should look like an abstract sketch or a doodle. Do not think and let your hand draw. Do it quickly, by not taking more than 30 seconds. 
3. At this point, please set aside the object itself. Look at the drawing, which is an expression of a neutral energy. How would you describe "it" in neutral, non-judgmental terms?
4. Please take another look at the energy drawing. Greet it, and just appreciate its special vibration, imagining it is radiating toward you. 
5. Feel its vibration emanating throughout  your body. How does it feel now? How would you use this energy in your own unique way/beneficial way? 
    `
  },
  'T-026': {
    id: 'T-026',
    name: 'Connecting with Energy through Energetic Membrane',
    content: `
1. Take a couple of deep breaths. Visualize the energetic membrane around you using "Creating Energy Container" tool. Connect with the inner stillness as you feel yourself inside the container.
2. Now, think of a person or a situation that you would like to know more about or you have tension with. Visualize their energy existing outside your energy field, pressing against the bubble of your energetic membrane. 
3. Imagine that your energy field will protect you from and "filter out" any negativity the experience may have. Now you are seeing the pure, neutral, judgment-free energy of the person or the situation. 
4. Raise your hand and imagine touching the point on the membrane's bubble where you see this energy. Try to feel the essence of that energy by letting it flow into your body.
5. Notice any change in your body. You may also find the image on the membrane also shifting. 
6. Imagine that this energy wants to be expressed through you in a beneficial way. Think of what you can do to incorporate it into your everyday life. 
    `
  },
  'T-027': {
    id: 'T-027',
    name: 'Letting Go of the Old Ideas',
    content: `
Do one or more of the following. Come back to the items regularly. 

- Reflect on your inner life from time to time.
- Make conscious efforts to reduce energy and time allocated for thought patterns, information and memories you no longer want to invest in.  
- Think of what you can do to bring any unfinished business to a closure. 
- Discard material objects that are related to certain memories you would like to part with, such as pictures, letters and gifts. 
- Ask someone you trust or a professional for help to work through difficult issues or past memories that are weighing you down. 
    `
  },
  'T-028': {
    id: 'T-028',
    name: 'Letting Go of the Old Exercise',
    content: `
1. On the scale of 1-10, with 1 being the lightest and 10 being the heaviest, how do you feel energetically at the moment?
2. Draw on a piece of paper a circle, representing your energy field. You can also use a piece of string to form a circle. 
3. Think of three things you feel have become old or obsolete that you need to let go of. This can be material possessions or certain thought or behavioral patterns that have similar characteristics to your South Node of the Moon (see Chapter 9). Write one item each on a small piece of paper and place them inside the circle.
4. Gently bring your awareness to what kept you from releasing them earlier. Just notice.
5. Pick up one of them in your hand and tune into how it feels. Reflect on it and appreciate how it may have supported you in the past in some way. 
6. Give gratitude to it and place it outside of the circle. Repeat with the other two. 
7. On the scale of 1-10, with 1 being the lightest and 10 being the heaviest, how do you feel energetically now?
    `
  },
  'T-029': {
    id: 'T-029',
    name: 'Anchoring New Energy Ideas',
    content: `
Do some or all of the following:

- Wear or carry something that reminds you of the new energy. For example, you can wear the color that resembles its vibration, or carry an object, like a small stone or clothing item.
- Place the paper with the words that describe the new energy, or an energy drawing you have made in the exercises, somewhere you can see during the day.
- Alternately, you can take a picture of the above and use it as a screen saver or wallpaper for your computer or cell phone. 
- Watch a movie or read a book with a character that has the similar energy you are trying to get to know more about.
- Observe and learn from a person who expresses such energy in a positive way. 
    `
  },
  'T-030': {
    id: 'T-030',
    name: 'Steps for Anchoring',
    content: `
1. Feel the new energy that you want to anchor once again using "Connecting with New Energy" techniques. 
2. Think of how you would express or create something with this new energy in a beneficial way that would contribute to your life as well as the world around you. 
3. Think of actionable steps toward actualizing it. 
4. Set reminders and follow through. 
    `
  }
};

export default toolsData;